import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const TableTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
`;
export const TableDescription = styled.h4`
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #6b6b6b;
`;

export const TableTitle = styled.h2`
    font-weight: 600;
    font-size: 24px;
    line-height: 143%;
    letter-spacing: 1.45%;
    margin: 0px;
`;

export const HighlightCount = styled.span`
    color: #0088ff;
`;
